import React from 'react';
import Viewer from '../../Viewer';
import { extConfigFullscreen } from '../../../Editor/presets/Gallection/config';
import cn from 'classnames';
import s from './Gallection.scss';
const GallectionViewer = /*#__PURE__*/ React.forwardRef(({ contentJson, className, externalRenderers, cookieType, defaultSize }, ref)=>{
    return /*#__PURE__*/ React.createElement(Viewer, {
        presetId: "gallection",
        contentJson: contentJson,
        className: cn(s['root'], className),
        extensionConfig: extConfigFullscreen,
        externalRenderers: externalRenderers,
        cookieType: cookieType,
        defaultSize: defaultSize,
        ref: ref
    });
});
GallectionViewer.displayName = 'GallectionViewer';
export default GallectionViewer;

//# sourceMappingURL=Gallection.js.map